import React from "react";
import "../../styles/ComponentsStyles/Universal/SuccessModal.style.css";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import CloseBtnIcon from "../../assets/Icons/Universal/CloseBtnIcon.svg";
const ScrollableModal = ({ isOpen = false, onClose, children }) => {
  const [modalStatus, setModalStatus] = useState(isOpen);
  useEffect(() => {
    setModalStatus(isOpen);
  }, [isOpen]);

  return (
    <div
      className={`successModal ${
        modalStatus ? "successModalOpen" : "successModalClose"
      }`}
    >
      <div
        className="modalBackground"
        onClick={() => {
          setModalStatus(false);
          onClose();
        }}
      ></div>

      <div
        className="successModalContent scroll-y h-full"
        style={{
          background: "transparent",
          display: "flex",
          flexDirection: "column",
          gap: "5rem",
          alignItems: "center",
          justifyContent: "flex-start",
        }}
      >
        <div className="h-fit w-full flex-col align-center justify-start g-2">
          <button
            className="transparentCardBtn flex align-center justify-center"
            style={{
              background: "#3A3A3A",
              width: "4rem",
              height: "4rem",
              borderRadius: "50%",
              border: "none",
            }}
            onClick={() => {
              setModalStatus(false);
              onClose();
            }}
          >
            <img
              src={CloseBtnIcon}
              style={{ width: "1rem", height: "1rem" }}
              alt=""
            />
          </button>
          <div className=" h-fit back-white p-1" style={{ width: "100%" }}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

ScrollableModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};
export default ScrollableModal;
